module.exports = __webpack_public_path__ + "static/media/instagram-brands.e75317fa.svg";